<template>
  <div class="home">
    <section class="main_content">
      <Category :categoriesName="categoryTree" @filterFeedProd="filterFeedProd" />
      <div class="user-specific-list" v-if="selectedCatId != 0 && childCategories.length">
        <div class="upper-part flx">
          <figure>
            <img :src="categoryNodeObject.bgImageURL" alt />
          </figure>
          <p>{{$t('doYouLikeThisCategory', {itemName : categoryNodeObject.name})}}</p>
        </div>
        <ul class="sub-cat-name">
          <li
            v-for="(category,index) in childCategories"
            :key="index"
            v-if="index < limit_by"
            :class="{'active' : (checkIndex(category.id) == 'active'), 'inactive' : (checkIndex(category.id) != 'active')}"
          >
            <span @click="selectValue(category.id)">{{category.name}}</span>
          </li>
          <li class="mt-1" @click="simple_toggle(default_limit, childCategories.length)">
            <span>{{ limit_by===3?'More..': 'Less'}}</span>
          </li>
        </ul>
        <!-- <div class="confirm-option flx">
          <button @click="addUserPrefence('REJECTED')"><span style="width: 10px;height: 10px;border-radius: 50%;display: block;background: #d0cdcd;margin-right: 5px;"></span> {{$t('dislikecategory')}}</button>
          <button @click="addUserPrefence('SELECTED')" class="yes"><span style="width: 10px;height: 10px;border-radius: 50%;display: block;background: #ff9933;margin-right: 5px;"></span> {{$t('likedCategory')}}</button>
        </div> -->
        <div class="warning-option flx">
          <button class="yes" @click="addUserPrefence('SELECTED')"> {{$t('saveNow')}}</button>
        </div>
      </div>
      <div class="sub_heading">
        <h4>{{$t('productsSpeciallyForYou')}}</h4>
      </div>
      <ul class="vertical-list">
        <li v-for="(product,index) in personalProdList" :key="index">
          <div class="prod-list">
            <div class="vertical-list-item" @click="goToProductDetail(product.saleReferenceID)">
              <figure class="img_wrapper spinner_wrapper" v-if="product.displayImage">
                <!-- <ImageSpinner class="image_spinner" /> -->
                <img :src="product.displayImage" alt="product" />
              </figure>
              <div class="product_detail">
                <p class="prod_name">{{product.productName}}</p>
                <p class="bought">
                  {{product.peopleBought}}
                  {{$t('peopleHaveBrought')}}
                </p>
                <div class="my_price_section">
                  <span class="my_price">
                    <span class="rupee-font">₹​</span>
                    {{product.pricingDTO.totalPaidAmount}}
                  </span>
                  <span class="selling_price">
                    <span class="rupee-font">₹​</span>
                    {{product.pricingDTO.mrp}}
                  </span>
                </div>

                <div v-if="parseFloat(product.pricingDTO.groupDiscount) > 0">
                  <hr style="margin: 5px 0;" />
                  <p class="group_price">
                    {{$t('groupDiscount')}}:
                    <strong>
                      <span class="rupee-font">₹​</span>
                      {{product.pricingDTO.groupDiscount}}
                    </strong>
                  </p>
                  <p
                    class="group_msg"
                  >{{$t('appliedDiscountOnPincde', {pincode: '', orderNumber: product.pricingDTO.minOrdersToFormNewGroup})}}</p>
                </div>
              </div>
            </div>
            <div class="item-liked flx" v-if="!product.likedbyme">
              <p>{{$t('doYouLikeThisItem')}}</p>
              <p>
                <span class="yes" @click="itemUserPrefence('SELECTED', product.saleReferenceID , index)">{{$t('yes')}}</span>
                <span @click="itemUserPrefence('REJECTED', product.saleReferenceID, index)">{{$t('no')}}</span>
              </p>
            </div>
            <div class="item-liked flx" v-if="product.likedbyme" style="text-align: center">
              <p style="width:100%; color:green;font-weight:bold">{{$t('likeThisItem')}}</p>
            </div>
            <!-- <div class="commission_level">
            <p class="commision_text">Commission</p>
            <ul class="level_step">
              <li>
                <span>Level 1</span>
                <span>₹120.0</span>
              </li>
              <li>
                <span>Level 2</span>
                <span>₹60.0</span>
              </li>
            </ul>
            </div>-->
          </div>
        </li>
      </ul>

      <ul class="no_record" v-if="notfounrdPrdt" style="margin-top: -40px;">
        <div class="page-status-panel">
          <div class="img-block">
            <img src="../assets/images/icons/norecord.svg" alt />
          </div>
          <div class="details-block">
            <h2>{{$t('noRecordFound')}}</h2>
            <!-- <p>Go to Mall</p> -->
            <!-- <router-link
              :to="{ path: '/home'}"
              tag="p"
              :class="{'active' : $route.path == '/home' }"
            >Go to Mall</router-link> -->
          </div>
        </div>
      </ul>
      <infinite-loading
        @infinite="getPersonalProductList"
        spinner="circles"
        :identifier="resetIdentifier"
        :class="{'visibilityHidden' : notfounrdPrdt}"
      >
        <template slot="no-results">{{$t('noMoreRecord')}}</template>
      </infinite-loading>
      <div class="cntntLoad" v-if="loading">
        <img src="../assets/images/loader.gif" />
      </div>
    </section>
  </div>
</template>

<script>
import ImageSpinner from "../components/Common/ImageSpinner";
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import { mapGetters } from "vuex";
import types from "../store/types";
import NoDataFound from "../components/Common/NoDataFound";
import InfiniteLoading from "vue-infinite-loading";
import Category from "../components/HomeSection/Category";
import Vue from "vue";
Vue.use(InfiniteLoading);
export default {
  name: "ForYou",
  components: {
    ImageSpinner,
    InfiniteLoading,
    NoDataFound,
    Category,
  },
  data() {
    return {
      pageIndex: 0,
      notfounrdPrdt: false,
      personalProdList: [],
      selectedCatId: 0,
      loading: false,
      default_limit: 3,
      limit_by: 3,
      isShow: true,
      selected: [],
      childCategories: [],
      categoryNodeObject: {},
      resetIdentifier: +new Date(),
      nonSelectIdList:[]
    };
  },
  created(){
    if(this.$refs.InfiniteLoading){
        this.$refs.InfiniteLoading.stateChanger.reset(); 
    }
  },
  computed: {
    ...mapGetters(["userInfo", "categoryTree"]),
  },
  methods: {
    simple_toggle(default_limit, filters_length) {
      this.limit_by =
        this.limit_by === default_limit ? filters_length : default_limit;
    },
    selectValue(category) {
      if (this.selected.length > 0) {
        let index = this.selected
          .map((it) => {
            return it;
          })
          .indexOf(category);
        if (index > -1) {
          let dataValue = this.selected.filter((it) => it != category);
          this.selected = dataValue;
        } else {
          this.selected.push(category);
        }
      } else {
        this.selected.push(category);
      }
    },
    checkIndex(category) {
      if (this.selected.length > 0) {
        let index = this.selected
          .map((it) => {
            return it;
          })
          .indexOf(category);
        if (index > -1) {
          return "active";
        } else {
          return "inactive";
        }
      } else {
        return "inactive";
      }
    },
    itemUserPrefence(value, id, index) {
      if(value === 'REJECTED'){
        let disableItem = document.querySelectorAll('.prod-list');
          disableItem[index].classList.add('disable');       
        setTimeout(()=>{
         this.personalProdList = this.personalProdList.filter(it=>it.saleReferenceID!=id)
        },500)            
      }
      if(value === 'SELECTED'){        
       let datavalue=Object.assign([],this.personalProdList)
       datavalue[index].likedbyme='yes'
       this.personalProdList=datavalue
      }
      this.$store.commit("saveProdListData", {
        personalProductList: this.personalProdList.filter(it=>it.saleReferenceID!=id),
        personalProdPageIndex: this.pageIndex,
        personalCategoryIndex: this.selectedCatId,
        subCategoryList: this.childCategories,
        categoryNodeItem: this.categoryNodeObject,
      }); 
      const obj = {
        itemId:id,
        userActionType: value
      }
      ApiCaller(
        constant.PERSONALIZED_URL,
        "add-user-preferences" ,
        "post",
        obj
      ).then(data =>{
        
      })
    },
    addUserPrefence(value) {      
      if(this.selected.length){
        this.loading = true
        const obj = {
        parentCategoryId: this.selectedCatId,
        subcategories: this.selected,
        userActionType: value,
      }
      ApiCaller(
        constant.PERSONALIZED_URL,
        "add-user-preferences",
        "post",
        obj
      ).then((data) => {
        this.loading = false
        this.personalProdList = [];
        this.pageIndex = 0;
        this.currentExpectedList = [];
        this.currentLikedItemList = [];
        this.resetIdentifier +=1;
      }).catch(err =>{
        this.loading = false
      })
      }else{
        this.loading = true
        const obj = {
          parentCategoryId: this.selectedCatId,
          subcategories: this.nonSelectIdList,
          userActionType: 'REJECTED',
        }
        ApiCaller(
          constant.PERSONALIZED_URL,
          "add-user-preferences",
          "post",
          obj
        ).then((data) => {
          this.loading = false
          this.personalProdList = [];
          this.pageIndex = 0;
          this.currentExpectedList = [];
          this.currentLikedItemList = [];
          this.notfounrdPrdt = true;
          this.limit_by = 3;
          this.$store.commit("saveProdListData", {
            personalProductList: this.personalProdList,
            personalProdPageIndex: this.pageIndex,
            personalCategoryIndex: this.selectedCatId,
            subCategoryList: this.childCategories,
            categoryNodeItem: this.categoryNodeObject,
          });
        }).catch(err =>{
          this.loading = false
        })
      }
      
    },
    filterFeedProd(value) {
      this.loading = true;
      this.selectedCatId = value;
      this.personalProdList = [];
      this.pageIndex = 0,
      this.childCategories = [];
      this.notfounrdPrdt = false;
      this.resetIdentifier +=1;
    },
    goToProductDetail(productSrId) {
      try {
        JSBridgePlugin.fireEvents("foryou_product_click");
      } catch (err) {
        console.log(err);
      }
      this.$router.push({
        path: "/detail/" + productSrId + "?source=USER_PERSONALIZED",
      });
    },
    getPersonalProductList($state) {
      if (this.$cookie.get("X-Auth-Id")) {
        const obj = {
          categoryId: this.selectedCatId,
          offset: this.pageIndex,
          limit: "20",
        };
        ApiCaller(
          constant.PERSONALIZED_URL,
          "user-personalized-items",
          "post",
          obj
        )
          .then((data) => {
            if (data.data.categoryNodeDTO) {
              this.categoryNodeObject = data.data.categoryNodeDTO;
              if(data.data.categoryNodeDTO.childCategories){
                this.childCategories = data.data.categoryNodeDTO.childCategories;
              this.selected = [];
              this.childCategories.filter((it) => {
                this.nonSelectIdList.push(it.id);
              });
              this.limit_by = 3;
              this.childCategories.filter((it) => {
                if (it.userSelected === true) {
                  this.selected.push(it.id);
                }
              });
              }
              
            }
            if (data.data.personalizedUserFeedDTOs && data.data.personalizedUserFeedDTOs.length > 0) {
              this.pageIndex += 1;
              this.personalProdList.push(...data.data.personalizedUserFeedDTOs);
              this.$store.commit("saveProdListData", {
                personalProductList: this.personalProdList,
                personalProdPageIndex: this.pageIndex,
                personalCategoryIndex: this.selectedCatId,
                subCategoryList: this.childCategories,
                categoryNodeItem: this.categoryNodeObject,
              });
              $state && $state.loaded();
              this.notfounrdPrdt = false;
              this.loading = false;
            } else {
              if (this.personalProdList.length == 0) {
                this.notfounrdPrdt = true;
              }
             
              this.loading = false;
              $state && $state.complete();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
  mounted() {
    this.$store.commit('noAddressCheck' , false)
    if (this.$cookie.get("X-Auth-Id")) {
     
      if (
        (
          this.$store.getters.personalProductList &&
          this.$store.getters.personalProductList.length > 0 &&
          this.$store.getters.personalProdPageIndex &&
          this.$store.getters.personalCategoryIndex) ||
          this.$store.getters.subCategoryList &&
          this.$store.getters.subCategoryList.length > 0 ||
          this.$store.getters.categoryNodeItem
      ) {
        this.personalProdList = this.$store.getters.personalProductList;
        this.pageIndex = this.$store.getters.personalProdPageIndex;
        this.selectedCatId = this.$store.getters.personalCategoryIndex;
        this.childCategories = this.$store.getters.subCategoryList;
        this.categoryNodeObject = this.$store.getters.categoryNodeItem;
        this.childCategories.filter((it) => {
          if (it.userSelected === true) {
            this.selected.push(it.id);
          }
        });
      }
      // this.getAllSubCategory()
    }
  },
};
</script>
<style lang="scss" scoped>
.user-specific-list {
  padding: 8px 16px 0;
  background: #363b41;
  margin: 16px;
  border-radius: 10px;
  color: #fff;
  font-family: "Hind", sans-serif;
  .upper-part {
    align-items: end;
    figure {
      width: 28%;
      min-height: 50px;
      background: #fff;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      img {
        max-width: 100%;
        max-height: 100%;
        overflow: hidden;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50% , -50%);
      }
    }
    p {
      font-size: 1em;
      padding: 0 8px 0 16px;
    }
  }
  .sub-cat-name {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding-bottom: 8px;
    border-bottom: 1px solid #565d64;
    li {
      background: #807d7d;
      color: #d0cdcd;
      font-size: 0.875em;
      margin-right: 8px;
      margin-top: 8px;
      padding: 4px 8px 2px;
      border-radius: 25px;
      font-weight: 500;
      &.active {
        background: #ff9933;
        color: #fff;
      }
      &.inactive{
        // background: #ff9933;
      }
    }
    .mt-1 {
      background: none;
      color: #32c5ff;
      padding: 0;
      span {
        background: none;
        color: #32c5ff;
        /* padding: 4px 0 2px; */
        /* margin: 0; */
        border-bottom: 1px solid;
        border-radius: 0;
        margin-top: 4px;
        display: block;
      }
    }
  }
  .warning-option {
    position: relative;
    padding-bottom: 8px;
    justify-content: center;
    button {
      background: none;
      border: 0;
      color: #fff;
      padding: 8px;
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      &.yes {
            color: #fff;
    background: #138808;
    margin-top: 8px;
    border-radius: 25px;
      }
    }
  }
  .confirm-option {
    position: relative;
    padding-bottom: 8px;
    button {
      background: none;
      border: 0;
      color: #fff;
      padding-top: 8px;
      width: 50%;
      display: flex;
    align-items: center;
    justify-content: center;
      &.yes {
        color: #ff9933;
      }
    }
    &:after {
      content: "";
      height: 30px;
      width: 1px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #565d64;
    }
  }
}
.vertical-list {
  padding: 0 16px;
  .prod-list {
    background-color: #ffffff;
    padding: 8px;
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
    margin: 0 0 8px 0;
    border-radius: 4px;
    &.disable{
      animation: linear fadeout 0.5s 1;
      @keyframes fadeout {
        0%{
          opacity: 1;
        }
        50%{
          height: 0.5;
        }
        100%{
           opacity: 0;
        }
      }
    }
  }
  .vertical-list-item {
    position: relative;
    width: 100%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    min-height: 85px;

    &.width100 {
      width: 100%;
    }

    & .img_wrapper {
      width: 35%;
      display: flex;
      align-items: center;
      border-radius: 10px;
      // padding: 8px 0;
      height: 74px;
      justify-content: center;

      img {
        border-radius: 10px;
        // background: antiquewhite;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .product_detail {
      width: 65%;
      padding-left: 10px;
      // font-family: $hindiFont;

      & p.prod_name {
        font-size: 0.875em;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.5;
        white-space: nowrap;
      }

      & p.bought {
        color: #9b9b9b;
        font-size: 0.75em;
      }

      & .my_price_section {
        span {
          display: inline-block;

          &.my_price {
            font-size: 1em;
            font-weight: 600;
            color: #00af72;
          }

          &.selling_price {
            //   font-family: $hindiFont;
            font-weight: 500;
            padding: 5px 10px 0;
            color: #3c3d49;
            font-size: 0.75em;
            text-decoration: line-through;
          }
        }
      }
      .group_msg {
        color: #3c3d49;
        font-size: 0.75em;
        line-height: 1.25;
      }
      .group_price {
        color: #ef835c;
        font-size: 0.75em;
        // border-top: 1px solid #9b9b9b;
        strong {
          font-size: 1.25em;
        }
      }
    }
  }
  .item-liked {
    font-size: 0.938em;
    font-family: "Hind", sans-serif;
    color: #505050;
    padding-top: 8px;
    border-top: 1px solid #c3bfbf;
    margin-top: 8px;
    p {
      span {
        padding: 8px;
        color: #505050;
        font-weight: 500;
        &.yes {
          color: #ff9933;
        }
      }
    }
  }
  .commission_level {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #e4ecff;
    width: 100%;
    background: #e4ecff;
    margin-top: 8px;
    border-radius: 4px;
    .commision_text {
      text-align: center;
      color: #5b5c91;
      font-size: 0.75em;
      width: 35%;
    }
    .level_step {
      width: 65%;
      background: #fff;
      li {
        display: flex;
        justify-content: space-between;
        font-size: 0.75em;
        color: #5b5c91;
        padding: 4px 8px;
        border-bottom: 1px solid #e4ecff;
        &:last-child {
          border-bottom: 0;
        }
        span {
          &:nth-child(2) {
            color: #000;
          }
        }
      }
    }
  }
}

.page-status-panel {
  width: 100%;
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.page-status-panel .img-block {
  width: 100%;
  height: 200px;
  margin-top: 40px;
}

.page-status-panel .bg_stars {
  background-image: url("../assets/images/icons/star_ptrn.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.page-status-panel .img-block img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.page-status-panel .details-block {
  width: 100%;
  padding: 15px;
  align-self: flex-end;
}

.page-status-panel .details-block h2 {
  color: #262626;
  font-size: 1.25em;
  text-align: center;
  padding: 15px 0px 20px;
}

.page-status-panel .details-block p {
  color: #b6bbbf;
  font-size: 1em;
  line-height: 28px;
  text-align: center;
}

.page-status-panel .btn-block {
  width: 100%;
  align-self: flex-end;
  padding-bottom: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.page-status-panel .btn-block span {
  background: #ff9933;
  padding: 10px 20px;
  font-size: 1em;
  color: #fff;
  border-radius: 9px;
}

.page-status-panel .btn-block .success {
  background: #138808;
}
</style>
